import Button, { ButtonVariants } from 'components/button';
import { css } from '@emotion/react';
import { Flex } from 'components/box';
import { Text, TextProps } from 'components/typography';
import { Link } from 'components/configurable-routing';

interface InformationButtonProps {
  iconSrc: any;
  text: string;
  iconWidth?: string;
  highlighted?: boolean;
  fontSize?: TextProps['fontSize'];
}

const InformationButtonInternal = ({
  iconSrc: Icon,
  text,
  iconWidth = '18px',
  highlighted = false,
  fontSize = [1, 2],
}: InformationButtonProps) => (
  <Flex
    justifyContent="flex-start"
    alignItems="baseline"
    css={css`
      gap: 4px;
    `}
    mb={1}
  >
    <Icon
      css={theme => css`
        stroke: ${highlighted ? theme.colors.primary : theme.colors.darkGrey};
        stroke-width: 2;
        fill: none;
        width: ${iconWidth};
      `}
    />

    <Text
      fontSize={fontSize}
      fontWeight={600}
      letterSpacing="initial"
      color={highlighted ? 'primary' : 'darkGrey'}
      css={theme => css`
        &:hover {
          color: ${theme.colors.primary};
        }
      `}
    >
      {text}
    </Text>
  </Flex>
);

export const InformationLink = ({
  href,
  ...restProps
}: { href: string } & InformationButtonProps) => (
  <Link
    mb={1}
    dynamicUrl="products/[id]"
    href={href}
    mr="3px"
    fontWeight={600}
    css={theme => css`
      text-transform: none;
      display: inline-block;
      font-family: ${theme.fonts.header};
      &:hover {
        color: ${theme.colors.primary};
        svg {
          stroke: ${theme.colors.primary};
        }
      }
    `}
  >
    <InformationButtonInternal {...restProps} />
  </Link>
);

export const InformationButton = ({
  onClick,
  ...restProps
}: { onClick: () => void } & InformationButtonProps) => (
  <Button
    variant={ButtonVariants.flat}
    onClick={onClick}
    p={0}
    fontWeight={600}
    fontColor="darkGrey"
    css={theme => css`
      text-transform: none;
      display: inline-block;
      font-family: ${theme.fonts.header};
      &:hover {
        color: ${theme.colors.primary};
        svg {
          stroke: ${theme.colors.primary};
        }
      }
    `}
  >
    <InformationButtonInternal {...restProps} />
  </Button>
);
